import { z } from 'zod';
/**
 * Bản bàn giao khi một người nghỉ dài — APM-AI-k (`plan-ai-features.md` mục 7).
 *
 * ## Vì sao nó phải nói "ai đang chờ", không chỉ "task nào"
 *
 * Danh sách task của người nghỉ thì một bộ lọc đã làm được. Thứ một bộ lọc
 * không làm được là trạng thái **trong đầu người ấy**: việc này đang mắc ở đâu,
 * ai bên ngoài đang chờ, bước kế tiếp là gì. Đó là phần chìm trong luồng bình
 * luận, và cũng là phần biến mất hoàn toàn khi người ta nghỉ.
 */
export const HandoverTask = z.object({
    taskId: z.uuid(),
    /** Một câu: việc đang ở đâu. */
    stateLine: z.string().min(1).max(400),
    nextStep: z.string().max(400).nullable(),
    /** Ai đang chờ việc này, hoặc việc này đang chờ ai. */
    waitingOn: z.string().max(300).nullable(),
    /** Người nhận đề xuất. `null` khi không ai còn chỗ — đó cũng là một câu trả lời. */
    proposedAssigneeId: z.uuid().nullable(),
    reason: z.string().min(1).max(400),
});
export const HandoverBrief = z.object({
    /** Người nghỉ. */
    personId: z.uuid(),
    /** Khoảng vắng mặt, dạng ngày ISO; `null` khi là rời dự án hẳn. */
    from: z.string().max(40).nullable(),
    to: z.string().max(40).nullable(),
    tasks: z.array(HandoverTask).max(40),
    /** Tài liệu người này tạo hoặc duyệt, cần người khác trông. */
    documentIds: z.array(z.uuid()).max(30),
    /** Quyết định người này đưa ra còn hiệu lực — người nhận cần biết để không lật lại. */
    decisionIds: z.array(z.uuid()).max(30),
    /** Rủi ro nếu không ai nhận. Rỗng là hợp lệ. */
    risks: z.array(z.object({ text: z.string().min(1).max(400) })).max(10),
});
//# sourceMappingURL=ai-handover.js.map